import onGetCarePlanByPatientId from './onGetCarePlanByPatientId';
import onReviewCarePlanByPatientId from './onReviewCarePlanByPatientId';

export default {
  onGetCarePlanByPatientId,
  onReviewCarePlanByPatientId,
};
